import { render, staticRenderFns } from "./QuickPhrasesList.vue?vue&type=template&id=54b5b4f2&scoped=true"
import script from "./QuickPhrasesList.vue?vue&type=script&lang=js"
export * from "./QuickPhrasesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b5b4f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54b5b4f2')) {
      api.createRecord('54b5b4f2', component.options)
    } else {
      api.reload('54b5b4f2', component.options)
    }
    module.hot.accept("./QuickPhrasesList.vue?vue&type=template&id=54b5b4f2&scoped=true", function () {
      api.rerender('54b5b4f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/systemSet/QuickPhrasesList.vue"
export default component.exports